import React from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useThemes } from "../../Theme/theme";
import { Close } from "@mui/icons-material";
function TDSTCSCustomSearch({ placeholder = "Search", onChange,searchValues ,onClick}) {
  console.log("sear",searchValues);
  
  const { theme } = useThemes();
  const theme1 = createTheme({
    palette: {
      mode: theme.palette.mode,
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          input: {
            fontSize: "15px", // Set the font size for input text
            "&::placeholder": {
              fontSize: "15px", // Set the font size for placeholder text
            },
            maxWidth: "180px",
            padding: "10px !important",
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            minWidth: "180px !important", // Set the minimum width for TextField
            maxWidth: "100px", // Additionally, you can enforce a maximum width
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          notchedOutline: {
            border: "none", // Set border to none
          },
        },
      },
    },
  });
  return (
    <ThemeProvider theme={theme1}>
      <TextField
        type="text"
        variant="standard"
        size="small"
        placeholder="Search"
        onChange={onChange}
        value={searchValues?searchValues:""}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {searchValues?(<>
                <IconButton onClick={onClick}>
                <Close />
              </IconButton>
              </>):
              <IconButton>
                <SearchIcon />
              </IconButton>}
            </InputAdornment>
          ),
        }}
        sx={{
          // "& .MuiInput-underline:before": {
          //   borderBottomColor: "transparent", // Hide default underline
          // },
          "& .MuiInput-underline:hover:before": {
            borderBottomColor: "transparent", // Hide underline on hover
          },
          "& .MuiInput-underline:after": {
            borderBottomColor: theme.palette.secondary.main, // Show custom color on focus
          },
          "& .MuiOutlinedInput-root": {
            height: "35px",
            borderRadius: "4px",
          },
          "& input": {
            padding: "8px",
          },
        }}
      />
    </ThemeProvider>
  );
}

export default TDSTCSCustomSearch;
